import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography, LinearProgress } from '@mui/material';

const ProcessingCard = ({ queueProgress }) => {
  const getProgressMessage = (progress) => {
    if (progress <= 30) return 'Finding experts...';
    if (progress <= 90) return 'Generating email drafts...';
    return 'Finalizing...';
  };

  return (
    <Paper sx={{ p: 3, textAlign: 'center', minHeight: '200px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <Typography variant="h6" sx={{ mb: 2, color: 'primary.main' }}>
        {getProgressMessage(queueProgress)}
      </Typography>

      <LinearProgress
        variant="determinate"
        value={queueProgress}
        sx={{
          height: 8,
          borderRadius: 4,
          mb: 2,
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          '& .MuiLinearProgress-bar': {
            borderRadius: 4,
          },
        }}
      />

      <Typography variant="body2" color="text.secondary">
        {queueProgress}% Complete
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontStyle: 'italic' }}>
        This usually takes 15-30 seconds
      </Typography>
    </Paper>
  );
};

ProcessingCard.propTypes = {
  queueProgress: PropTypes.number.isRequired,
};

export default ProcessingCard;
